import { __makeTemplateObject } from "tslib";
import styled from "styled-components";
export var InputsArea = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  gap: ", ";\n  padding-top: ", ";\n"], ["\n  display: flex;\n  flex-direction: column;\n  gap: ", ";\n  padding-top: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.spacing.xs;
}, function (_a) {
    var theme = _a.theme;
    return theme.spacing.s;
});
export var DateHourInput = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n  gap: ", ";\n  align-items: center;\n  justify-content: flex-end;\n"], ["\n  display: flex;\n  gap: ", ";\n  align-items: center;\n  justify-content: flex-end;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.spacing.xxs;
});
export var OptionsList = styled.ul(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  list-style: none;\n  gap: ", ";\n  padding: ", ";\n  border-right: 1px solid ", ";\n\n  li {\n    white-space: nowrap;\n    color: ", ";\n    font-family: ", ";\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 20px; /* 142.857% */\n    letter-spacing: 0.1px;\n    cursor: pointer;\n\n    &:hover {\n      text-decoration: underline;\n    }\n  }\n"], ["\n  display: flex;\n  flex-direction: column;\n  list-style: none;\n  gap: ", ";\n  padding: ", ";\n  border-right: 1px solid ", ";\n\n  li {\n    white-space: nowrap;\n    color: ", ";\n    font-family: ", ";\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 20px; /* 142.857% */\n    letter-spacing: 0.1px;\n    cursor: pointer;\n\n    &:hover {\n      text-decoration: underline;\n    }\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.spacing.s;
}, function (_a) {
    var theme = _a.theme;
    return theme.spacing.s;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.neutral.lighter;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.neutral.dark;
}, function (_a) {
    var theme = _a.theme;
    return theme.typography.family.default;
});
var templateObject_1, templateObject_2, templateObject_3;
//# sourceMappingURL=styles.js.map